import { useEffect, useState } from "react"
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import axios from 'axios';
import { RECORD } from '../../constants'
import RecordLine from "../../components/TextComps/RecordLine";


export default function GetRecords() {

    const exam_url = RECORD

    const [open, setOpen] = useState(false);
    const handleOpen = () => {setOpen(true);};
    const handleClose = () => {setOpen(false);};
  
       const [record, setRecord] = useState([])  
       const [loading, setLoading] = useState(false);   
       const [error, setError] = useState();

      useEffect(() => {

        setLoading(true)
        axios.get(exam_url)
          .then((response) => {
            setRecord(response.data);
            //console.log(response.data)
            setLoading(false)
            }) 
          .catch(function (error) {
            setLoading(false)
            //throw new Error(error)
            setError(error.toJSON());
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              //console.log(error.response.data, error.response.status);
              
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of http.ClientRequest in node.js
              //console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              //console.log('Error', error.message);
            }
            //console.log(error.config);
            console.log("Error")
          })
        }, []);

//  const addresses = data.map(i => i.selectedImage)

//const docs = () => {
//{record.map((x, index) => (
//  <ImageGallery key={index} items={ x.images.map(i => { return {'original': i.image, 'thumbnail': i.image} }) } showIndex={true} />
//  )) }
//}

return (
 <>   



  {record.map((d, index) => (
    
    <RecordLine key={index} 
        
        date={d.date} 
        incident={d.incident} 
        content={d.content} 

        images={ d.images.map(i => { return {'original': i.image, 'thumbnail': i.image} }) }
                             
      /> 
          
    ))} 


  {error  ? (
    <Alert severity="error" sx={{mt:2}}>
        <Typography variant="body2"  sx={{fontWeight: '500'}}> {error.message} </Typography>
    </Alert>
    ) : (null)
    }

 
</>  )
}

